export const ALEA90 = {
  id: 'alea90-2026', amount: 899, currency: 'MXN', capacity: 180,
  registration: '10 oct — 20 nov 2026', announcement: '21 de noviembre de 2026',
  // Fail closed: autorización comercial, bases y backend verificado pendientes.
  paymentsEnabled: false,
} as const;

export const inclusions = {
  Rostro: [
    ['3', 'Limpiezas faciales'],
    ['3 áreas', 'Botox'],
    ['3 ml', 'Ácido hialurónico', 'Labios, mentón o pómulos, según valoración.'],
    ['3', 'Sesiones de PDRN de salmón'],
    ['3', 'Sesiones de Dermapen', 'Con exosomas o PRP.'],
    ['6', 'Sesiones de enzimas', 'Para contorno facial.'],
  ],
  Cuerpo: [
    ['24', 'Sesiones de carboxiterapia', 'Abdomen, espalda, brazos y piernas.'],
    ['12', 'Sesiones de enzimas', 'Abdomen y espalda.'],
    ['4', 'Sesiones de hidrolipoclasia', 'Abdomen, espalda y piernas.'],
    ['36', 'Tratamientos / masajes reductivos', 'Pueden incluir cavitación, vacuumterapia, sauna, presoterapia, radiofrecuencia y electrodos.'],
    ['3', 'Sesiones de drenaje linfático'],
    ['3', 'Exfoliaciones corporales'],
  ],
  Bienestar: [
    ['3 meses', 'Gimnasio'],
    ['Personalizado', 'Plan nutricional', 'Acompañamiento por nutriólogo.'],
  ],
} satisfies Record<string, string[][]>;
